import React, { useState } from "react";

import { useIntl } from "react-intl";

import InternalTag from "Components/InternalTag";
import TimeframeControl from "src/organization/pages/project/environment/metrics/components/timeframeControl/TimeframeControl";
import useInitialTimeframe from "src/organization/pages/project/environment/metrics/hooks/useInitialTimeframe";

import usePinnedTabsSync from "../hooks/usePinnedTabsSync";
import useStickyTimecontrol from "../hooks/useStickyTimecontrol";

import LogsFilters from "./components/overview/LogsFilter";
import LogsTable from "./components/table/LogsTable";
import useLogs from "./hooks/useLogs";
import LogsSkeleton from "./LogsSkeleton";
import LogsOverview from "./overview/LogsOverview";
import * as S from "./style";
import { PageTimeFrameType } from "./types";

const Page = () => {
  const intl = useIntl();

  const initialTimeframe = useInitialTimeframe({ id: "24h" });
  const [timeFrame, setTimeFrame] =
    useState<PageTimeFrameType>(initialTimeframe);

  const { onSyncChange, isSynced, canJoinSync } = usePinnedTabsSync({
    timeFrame: timeFrame,
    setTimeFrame: setTimeFrame
  });

  const handleSyncChange = (isSynced: boolean) => {
    onSyncChange(isSynced, timeFrame);
  };

  const { data, actions, status } = useLogs(timeFrame);
  const { logsOverview, logs, selection } = data;
  const { isSkeletonVisible, loadingMoreLogs } = status;
  const { handleLoadMore, handleFiltersChange } = actions;

  const stickyRef = useStickyTimecontrol();

  return (
    <div>
      <S.HeaderSection ref={stickyRef}>
        <S.PageTitle tag="h3">
          {intl.formatMessage({ id: "logs" })} <InternalTag />
        </S.PageTitle>

        <S.ChartFilterContainer>
          <TimeframeControl
            timeframe={{
              timeframe: timeFrame,
              onChange: setTimeFrame
            }}
            tabSync={{
              onSyncChange: handleSyncChange,
              isSynced,
              canJoinSync
            }}
          />
        </S.ChartFilterContainer>
      </S.HeaderSection>
      <LogsSkeleton isLoading={isSkeletonVisible}>
        <S.LogsExplorer>
          {logs && (
            <>
              {logsOverview && (
                <>
                  <LogsFilters
                    filters={logsOverview.filters}
                    selection={selection}
                    onChange={handleFiltersChange}
                  ></LogsFilters>
                  <LogsOverview
                    data={logsOverview.data}
                    timeframe={timeFrame}
                  ></LogsOverview>
                </>
              )}
              {logs && (
                <LogsTable
                  logs={logs}
                  onLoadMore={handleLoadMore}
                  loadingMoreLogs={loadingMoreLogs}
                ></LogsTable>
              )}
            </>
          )}
        </S.LogsExplorer>
      </LogsSkeleton>
    </div>
  );
};

export default Page;
